import AssertionEntity from '../../lib/FormValidator/Assertion/AssertionEntity';
import AssertionItem from '../../lib/FormValidator/Assertion/AssertionItem';
export class TorneoOfflineAssertions extends AssertionEntity {
  private constructor() {
    super();
  }

  static build() {
    const instance = new this();
    instance.addAssertionForName();
    instance.addAssertionForCat();
    instance.addAssertionForDiv();
    instance.addAssertionForRama();
    instance.addAssertionForCantPer();
    instance.addAssertionForDurPer();
    instance.addAssertionForCantTiempoExtra();
    instance.addAssertionForDurTiempoExtra();
    instance.addAssertionForCantPerTE();
    instance.addAssertionForDurPerTE();
    return instance;
  }

  addAssertionForName(key = 'toro_nombre') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Nombre es obligatorio'
      )
    );
  }

  addAssertionForCat(key = 'toro_cat') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Categoria es obligatorio'
      )
    );
  }

  addAssertionForDiv(key = 'toro_div') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Division es obligatorio'
      )
    );
  }

  addAssertionForRama(key = 'toro_rama') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Rama es obligatorio'
      )
    );
  }

  addAssertionForCantPer(key = 'toro_cant_per') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value;
        },
        key,
        'Cantidad de periodos es obligatorio'
      )
    );
  }

  addAssertionForDurPer(key = 'toro_dur_per') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value;
        },
        key,
        'Duracion de periodos es obligatorio'
      )
    );
  }

  addAssertionForCantTiempoExtra() {
    this.defineAssertionForObject(
      AssertionItem.forClosure(
        (value: any) => {
          console.log('VALUE', value);
          if (!value.toro_emp) {
            const cant_te = value.toro_cant_te;
            return cant_te;
          } else {
            return false;
          }
        },
        'toro_cant_te',
        'La cantidad es obligatoria'
      )
    );
  }

  addAssertionForDurTiempoExtra() {
    this.defineAssertionForObject(
      AssertionItem.forClosure(
        (value: any) => {
          console.log('VALUE', value);
          if (!value.toro_emp) {
            const dur_te = value.toro_dur_te;
            return dur_te;
          } else {
            return false;
          }
        },
        'toro_dur_te',
        'La duracion es obligatoria'
      )
    );
  }

  addAssertionForCantPerTE(key = 'toro_cant_te') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value;
        },
        key,
        'Cantidad de periodos es obligatorio'
      )
    );
  }

  addAssertionForDurPerTE(key = 'toro_dur_te') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value;
        },
        key,
        'Duracion de periodos es obligatorio'
      )
    );
  }
}
